import {
    REQUEST_LIQUIDATIONS_STATS,
    RECEIVE_LIQUIDATIONS_STATS,
    ERROR_LIQUIDATIONS_STATS,
} from '../types'
import {initialFetchState} from '../../constants/defaultValues'
import {loadDataRefresh} from "../../constants/constants"

export default (state = initialFetchState, action = {}) => {
    switch(action.type) {
        case REQUEST_LIQUIDATIONS_STATS:
            return {
                ...state,
                isFetching: true,
                message: '',
                errors: {}
            }
        case RECEIVE_LIQUIDATIONS_STATS:
            return {
                ...state,
                isFetching: false,
                data: action.payload,
                validUntil: loadDataRefresh.default + Date.now(),
                message: '',
            }
        case ERROR_LIQUIDATIONS_STATS:
            return {
                ...state,
                isFetching: false,
                errors: action.errors,
                message: action.errors.server || '',
            }
        default:
            return state
    }
}